import { toDateBR } from './formatters'

export function getTextCodigoPagamento (formaPagamento, codigoPagamentoCliente, dataValidade) {
  if (formaPagamento === 'link' && codigoPagamentoCliente) {
    const dataExpiracao = criarObjetoDate(dataValidade)
    const dataAtual = new Date()
    dataAtual.setHours(0, 0, 0, 0)
    const isValido = dataValidade && (dataExpiracao >= dataAtual)
    const validadeTexto = isValido ? ' Expira em ' + toDateBR(dataValidade) : ' - Expirado, reenvie um novo código de pagamento.'
    return codigoPagamentoCliente + validadeTexto
  } else if (formaPagamento !== 'link' && codigoPagamentoCliente) {
    return codigoPagamentoCliente + ' - Expirado, reenvie um novo código de pagamento.'
  } else {
    return 'Forma de pagamento não selecionada.'
  }
}

function criarObjetoDate (dataString) {
  const [datePart] = dataString.split('T')
  const [ano, mes, dia] = datePart.split('-')
  return new Date(ano, mes - 1, dia)
}
